// extracted by mini-css-extract-plugin
module.exports = {"root":"_3RQwS","text":"ptZsF","buttonsContainer":"_3xonM","button":"_7jSmx"};